import { default as classnames, default as cn } from 'classnames';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import MarketWbApi from '../../../../../API/market/wb-api';
import { Column, Row } from '../../../../../components/Basic/Blocks';
import { CheckButton } from '../../../../../components/Basic/Buttons';
import { Link } from '../../../../../components/Basic/Elements';
import { EditInput, Input } from '../../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import CommissionNdsBlock from '../../../../../components/Markets/Blocks/CommissionNdsBlock';
import { formFullDate, numberWithSpaces } from '../../../../../utils';
import calcWbCommission, { calcWbProfit, calcWbSPP } from '../../../../../utils/wb';
import styles from './styles.module.scss';
import { GO_TO_WB } from '../../../../../components/Markets/Blocks/Table/Line';
import ProviderList from '../../../../../components/Common/Input/ProviderList';

const width = ['150px', '400px', '130px', '140px', '150px', '180px', '120px', '80px', '100px', '40px'];

const WbTableSizes = ({ postings = [], map = {}, shop, setMap = () => { }, ...props }) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const onChangeProduct = async (offer_id, shop, key, value) => {
    let setCard = (card) => {
      setMap({ ...map, [shop]: { ...map[shop], [card.offer_id]: card } });

      //setCards({ ...cards, byId: { ...cards.byId, [offer_id]: card } });
    };
    if (key === 'stock') {
      return await MarketWbApi.changeStock({ data: { shop, offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price' || key === 'discount') {
      return await MarketWbApi.changePrice({ data: { shop, offer_id, field: key, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'percent' || key === 'min_rub') {
      return await MarketWbApi.changeMarginality({ data: { shop, offer_id, field: key, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketWbApi.changeStopBrand({ data: { shop, offerIds: [offer_id], value } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    return await MarketWbApi.changeCard({ data: { shop, offer_id, field: key, value } })
      .then((r) => {
        setCard(r.card);
      })
      .catch((e) => console.log(e));
  };

  const shipmentOrders = async () => { };

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Table styles={styles.ozon_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width="90px" noBorder />
          <HeaderTitle width={width[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={width[3]} centerText>
            Площадка
          </HeaderTitle>
          <HeaderTitle width={width[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={width[8]} centerText>
            Длина упаковки
          </HeaderTitle>
          <HeaderTitle width={width[8]} centerText>
            Ширина упаковки
          </HeaderTitle>
          <HeaderTitle width={width[8]} centerText>
            Высота упаковки
          </HeaderTitle>
          <HeaderTitle width={width[8]} centerText>
            Едицина измерения
          </HeaderTitle>
          <HeaderTitle width={width[8]} centerText>
            Объем
          </HeaderTitle>
          <HeaderTitle width={width[9]} centerText />
          <HeaderTitle width={width[8]} centerText>
            Едицина измерения
          </HeaderTitle>
          <HeaderTitle width={width[8]} centerText>
            Стоимость доставки
          </HeaderTitle>
          <HeaderTitle width={width[4]} centerText>
            Прибыль/комиссия
          </HeaderTitle>
          {isOwner && (
            <>
              <HeaderTitle width={width[3]} centerText>
                Цена продажи
              </HeaderTitle>
              <HeaderTitle width={width[3]} centerText>
                Цена закупки
              </HeaderTitle>
            </>
          )}
          <HeaderTitle width={width[5]} centerText>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Артикул поставщика
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Количество в заказе
          </HeaderTitle>
        </TableHeader>
        {postings.map((order, key) => {
          const mapByShop = map[order.shop];

          const info = { ...mapByShop[order.offer_id] };

          const loaded = !!mapByShop[order.offer_id];
          const init_price = (mapByShop[order.offer_id] || {}).prices?.price;

          const sizes_package = info.sizes_package || {};
          const commission = calcWbCommission(info, shop);
          const profit = loaded ? calcWbProfit(info, shop) : 0;
          const spp = calcWbSPP(init_price, order.cost);
          //  const profit = loaded ? calcWbProfit(info, true) : 0;
          return (
            <TableLine
              key={order.order_id}
              styles={cn(
                order.userStatus === 'Возврат' && styles.red_line,
                info.status_flags?.is_check_size && styles.green_line,
              )}
            >
              <TableCell width="90px" minWidth="90px">
                <Row>
                  <div>{key + 1} </div>
                  <div className={styles.wrapper}>
                    <img
                      onClick={() => openImageViewer(info.images ? info.images : [])}
                      className={styles.preview}
                      src={info.images ? info.images[0] : undefined}
                    />
                  </div>
                </Row>
              </TableCell>
              <TableCell width={width[3]}>
                <Column style={{ alignItems: 'center' }}>{order.shop}</Column>
              </TableCell>
              <TableCell width={width[0]} minWidth={width[0]}>
                <div className={styles.blue_text}>{order.order_id} </div>
                <TextGrey style={{ width: '100%', fontSize: 14 }}>{formFullDate(order.date_created)}</TextGrey>

                <Text fontWeight={500} fontSize={16} lineHeight="25px">
                  <Link
                    blue={true}
                    href={GO_TO_WB(info.nmID)}
                    style={{ width: '100%', fontSize: '14px' }}
                    target="_blank"
                  >
                    {info.nmID}
                  </Link>
                </Text>
              </TableCell>
              <TableCell width={width[1]} minWidth={width[1]}>
                <div className={styles.div_line_images}>
                  <div className={styles.name}>
                    {!!mapByShop[order.offer_id] ? (
                      <EditInput
                        name={info.name}
                        onChange={(v) => onChangeProduct(info.offer_id, order.shop, 'name', v)}
                      />
                    ) : (
                      ''
                    )}
                  </div>
                  <TextGrey fontSize={14}>{info.offer_id || ''} </TextGrey>
                </div>
              </TableCell>

              <TableCell minWidth={width[8]} width={width[8]} center>
                <Input
                  value={sizes_package.depth}
                  onBlur={(v) => onChangeProduct(info.offer_id, order.shop, 'depth', v)}
                  center
                />
              </TableCell>
              <TableCell minWidth={width[8]} width={width[8]} center>
                <Input
                  value={sizes_package.width}
                  onBlur={(v) => onChangeProduct(info.offer_id, order.shop, 'width', v)}
                  center
                />
              </TableCell>
              <TableCell minWidth={width[8]} width={width[8]} center>
                <Input
                  value={sizes_package.height}
                  onBlur={(v) => onChangeProduct(info.offer_id, order.shop, 'height', v)}
                  center
                />
              </TableCell>
              <TableCell minWidth={width[8]} width={width[8]} center>
                см
              </TableCell>
              <TableCell minWidth={width[8]} width={width[8]} center>
                <Text fontWeight={600}>{sizes_package.volume}</Text>
              </TableCell>
              <TableCell minWidth={width[9]} width={width[9]} center>
                <CheckButton
                  checked={info.status_flags?.is_check_size}
                  onSelect={() =>
                    onChangeProduct(info.offer_id, order.shop, 'is_check_size', !info.status_flags?.is_check_size)
                  }
                />
              </TableCell>
              <TableCell minWidth={width[8]} width={width[8]} center>
                см
              </TableCell>
              <TableCell minWidth={width[8]} width={width[8]} center>
                <Text fontWeight={700} className={styles.color_delivery}>
                  {order.commission?.delivery?.rub}
                </Text>
              </TableCell>

              <TableCell width={width[4]} minWidth={width[4]}>
                {isOwner ? (
                  <Column>
                    <div className={styles.div_commission}>
                      {loaded && (
                        <>
                          <Text className={classnames(styles.block_mar, order.profit?.is_minus && styles.red_text)}>
                            {order.profit?.percent ? Math.ceil(order.profit?.percent) : '-'} %
                          </Text>
                          <div className={styles.block_commission}>
                            <Text
                              fontWeight={600}
                              className={order.profit?.is_minus ? styles.red_text : styles.green_text}
                            >
                              {order.profit?.percent ? numberWithSpaces(Math.ceil(order.profit?.rub)) : '-'}
                            </Text>
                            <CommissionNdsBlock card={{ ...mapByShop[order.offer_id], ...order }} market={'WB'} />
                          </div>
                        </>
                      )}
                    </div>
                  </Column>
                ) : (
                  <Column style={{ alignItems: 'center' }}>
                    {loaded && (
                      <Text
                        className={profit < 0 ? styles.red_text : styles.green_text}
                        style={{ textAlign: 'center' }}
                      >
                        {profit < 0 ? `В минус на ${profit}` : 'ок'}
                      </Text>
                    )}
                  </Column>
                )}
              </TableCell>

              {isOwner && (
                <>
                  <TableCell width={width[3]} minWidth={width[3]} center>
                    <div className={cn(styles.div_line, styles.div_price, order.cost !== init_price && styles.sale)}>
                      {/*
                      {Math.ceil(order.price)}
*/}
                      <Row>
                        <Text fontSize={16} fontWeight={600}>
                          {init_price}
                        </Text>{' '}
                        / {Math.ceil(order.cost)} {order.currencyCode}{' '}
                        {(spp > 0 || spp < 0) && <Text fontSize={12}>({spp} %)</Text>}
                      </Row>
                      {/*
                      {order.cost !== init_price && <Text>скидка</Text>}
*/}
                      {/*
                      {order.cost !== init_price && <Text>скидка</Text>}
*/}
                    </div>
                  </TableCell>
                  <TableCell width={width[3]} minWidth={width[3]}>
                    <Input
                      value={info.purchase}
                      onBlur={(v) => onChangeProduct(info.offer_id, order.shop, 'purchase', v)}
                      center
                    />
                  </TableCell>
                </>
              )}

              <TableCell width={width[5]} minWidth={width[5]}>
                <Column style={{ alignItems: 'center' }}>
                  <div className={styles.div_line}>
                    <ProviderList
                      selectProviderId={info.provider_id}
                      disabled={true}
                      onSelect={(v) => onChangeProduct(info.offer_id, order.shop, 'provide_id', v.id)}
                    />
                  </div>
                </Column>
              </TableCell>
              <TableCell width={width[6]} minWidth={width[6]}>
                <div className={styles.div_line}>
                  <Input
                    value={info.provider_artnumber}
                    onBlur={(v) => onChangeProduct(info.offer_id, order.shop, 'provider_artnumber', v)}
                    center
                  />
                </div>
              </TableCell>

              <TableCell width={width[6]} minWidth={width[6]}>
                <div className={styles.div_line}>
                  <Input
                    value={info.quantity}
                    onBlur={(v) => onChangeProduct(info.offer_id, order.shop, 'quantity', v)}
                    center
                  />
                </div>
              </TableCell>
            </TableLine>
          );
        })}
      </Table>
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default WbTableSizes;
